exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".follow-links{display:flex;flex-direction:column}.follow-links__socials{display:flex;flex-direction:row;margin-bottom:20px}.follow-links__link{color:#8e8d8d;display:flex;flex-direction:row;margin-bottom:10px}.follow-links__spotify{margin-bottom:30px}.follow-links__x{margin-right:24px}.follow-links__icon{margin-right:20px}@media (max-width: 768px){.follow-links{flex-direction:column}.follow-links__spotify{padding-left:0}}\n", ""]);

// exports
exports.locals = {
	"follow-links": "follow-links",
	"follow-links__socials": "follow-links__socials",
	"follow-links__link": "follow-links__link",
	"follow-links__spotify": "follow-links__spotify",
	"follow-links__x": "follow-links__x",
	"follow-links__icon": "follow-links__icon"
};